<jhi-bary-card titleKey="transport-edi-history.title">
  <div class="col-12" body>
    <div class="row" *ngFor="let ediHistory of ediHistories; let index = index">
      <div class="col">
        <p>
          <mdb-icon fas icon="check" class="color-success mr-1"></mdb-icon>
          {{ writeLine(ediHistory, index) }}
        </p>
      </div>
      <div class="col-auto" *ngIf="displayDownloadEdiFile">
        <a (click)="downloadEdiFile(ediHistory)">
          <p>
            <mdb-icon fas icon="cloud-download-alt"></mdb-icon>
          </p>
        </a>
      </div>
    </div>
  </div>
</jhi-bary-card>
